﻿export interface RectCropData {
    base64: string;
    page: number;
    selectedText: string;
}

export function captureCanvasCrop(pageDiv: HTMLElement, selLeft: number, selTop: number, selRight: number, selBottom: number): string | null {
    const canvas = pageDiv.querySelector('canvas');
    if (!canvas) return null;
    const scaleX = canvas.width / canvas.clientWidth;
    const scaleY = canvas.height / canvas.clientHeight;
    const cropX = Math.round(selLeft * scaleX);
    const cropY = Math.round(selTop * scaleY);
    const cropW = Math.round((selRight - selLeft) * scaleX);
    const cropH = Math.round((selBottom - selTop) * scaleY);
    if (cropW < 1 || cropH < 1) return null;
    const tmp = document.createElement('canvas');
    tmp.width = cropW;
    tmp.height = cropH;
    const ctx = tmp.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(canvas, cropX, cropY, cropW, cropH, 0, 0, cropW, cropH);
    return tmp.toDataURL('image/png');
}
